
export default {
    changeRN(data) {
        if (!data) {
            return '';
        };
        var result = '';
        let newData = data.split('\r\n');
        newData.forEach(function (val, index) {
            if (index == 0) {
                result += val;
            } else {
                result += '<br>' + val;
            };
        });
        return result;
    }
}